import React, { cloneElement } from "react";
import SidebarItem from "../../components/SidebarItem";
import ResourceDataMap from "../../components/ResourceDataMap";
import { links_cabinet } from "routes/navigation/sidebarLinks";
import PropTypes from "prop-types";
import logo from "../../image/logo.png";
import useGetCurrentUser from "hooks/useGetCurrentUser";
import "./style.css";
import { useGetUsersByIdQuery } from "actions/users/queries";
import InitialsAvatar from "components/InitialsAvatar";

const SidebarComponentCabinet = ({
  activeLinkColor,
  activeLinkBgColor,
  colorOnHover,
  linkColor,
  openedMenu,
}) => {
  const ClonedSidebarItem = ({ linkItem }) =>
    cloneElement(
      <SidebarItem linkItem={linkItem} openedMenu={openedMenu} inDossier={false} />,
      {
        activeLinkColor,
        activeLinkBgColor,
        colorOnHover,
        linkColor,
      }
    );

  const user = useGetCurrentUser();
  const { data: userStatus } = useGetUsersByIdQuery(user?.id);

  return (
    <div className={`sidebar-shell hideScrollbar ${openedMenu ? "is-collapsed" : ""}`}>
      <div className="sidebar-header-block">
        <div style={{ marginBottom: 20 }}>
          <img src={logo} alt="Easy Compta" style={{ width: "58%", maxWidth: 160 }} />
        </div>
        <div className="sidebar-user-card">
          <div style={{ width: 36, height: 36, flexShrink: 0 }}>
            <InitialsAvatar
              firstName={user?.first_name}
              lastName={user?.last_name}
              photoURL={userStatus?.photo_url}
              alt="user"
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          </div>
          <div style={{ minWidth: 0 }}>
            <div style={{ fontSize: 13, fontWeight: 600, color: "#1f2937" }}>
              {user?.first_name} {user?.last_name}
            </div>
            <div style={{ fontSize: 11, color: "#009688", fontWeight: 600 }}>
              {user?.isExpertComptable === true ? "Expert Comptable" : user?.status}
            </div>
          </div>
        </div>
        <input type="text" className="sidebar-search" placeholder="Recherche" />
      </div>

      <p className="sidebar-section-title">Aperçu</p>

      <div className="sidebar-nav-scroll">
        <ResourceDataMap
          resourceData={links_cabinet}
          resourceItem={ClonedSidebarItem}
          resourceName="linkItem"
        />
      </div>
    </div>
  );
};

SidebarComponentCabinet.propTypes = {
  activeLinkColor: PropTypes.string.isRequired,
  activeLinkBgColor: PropTypes.string.isRequired,
  colorOnHover: PropTypes.string.isRequired,
  linkColor: PropTypes.string.isRequired,
  openedMenu: PropTypes.bool.isRequired,
};

export default SidebarComponentCabinet;

export const SideBarLinkCabinet = () => {
  return <div></div>;
};
